import {RouteObject} from 'react-router-dom';
import {authGuard} from '@common/auth/guards/auth-route';

const lazyRoute = async (
  cmp: keyof typeof import('@app/web-player/routes/web-player-routes.lazy'),
) => {
  const exports = await import('@app/web-player/routes/web-player-routes.lazy');
  return {
    Component: exports[cmp],
  };
};

export const webPlayerRoutes: RouteObject[] = [
  {
    path: 'newsletter/link/:token',
    lazy: () => lazyRoute('NewsletterLinkResolverPage'),
  },
  {
    path: 'track/:trackId/:trackName/embed',
    loader: () => authGuard({permission: 'medias.view', requireLogin: false}),
    lazy: () => lazyRoute('TrackEmbed'),
  },
  {
    path: 'album/:albumId/:artistName/:albumName/embed',
    loader: () => authGuard({permission: 'medias.view', requireLogin: false}),
    lazy: () => lazyRoute('AlbumEmbed'),
  },
  {
    path: 'album/:albumId/:derivedId/:artistName/:albumName/embed',
    loader: () => authGuard({permission: 'medias.view', requireLogin: false}),
    lazy: () => lazyRoute('AlbumEmbed'),
  },
  {
    path: 'landing',
    lazy: () => lazyRoute('LandingPage'),
  },
  {
    path: 'live-votes/:slugOrId/displayer',
    lazy: () => lazyRoute('LiveVotePageDisplayer'),
  },
  {
    path: '/',
    id: 'webPlayerRoot',
    lazy: () => lazyRoute('Homepage'),
    children: [
      {
        index: true,
        id: 'webPlayerIndex',
        lazy: () => lazyRoute('HomepageChannelPage'),
      },
      {
        path: 'notifications',
        lazy: () => lazyRoute('NotificationsPage'),
      },
      {
        path: 'in/pages/:type',
        lazy: () => lazyRoute('CustomPagesList'),
      },
      {
        path: 'in/pages/:pageId/:pageSlug',
        lazy: () => lazyRoute('CustomPageRender'),
      },
      {
        path: 'lyrics',
        lazy: () => lazyRoute('LyricsPage'),
      },
      // artists
      {
        path: 'artist/:artistId/:artistName',
        lazy: () => lazyRoute('ArtistPage'),
      },
      {
        path: 'artist/:artistId',
        lazy: () => lazyRoute('ArtistPage'),
      },
      // playlists
      {
        path: 'playlist/:playlistId/:playlistName',
        lazy: () => lazyRoute('PlaylistPage'),
      },
      // albums
      {
        path: 'album/:albumId/:derivedId/:artistName/:albumName',
        lazy: () => lazyRoute('AlbumPage'),
      },
      {
        path: 'album/:albumId/:artistName/:albumName',
        lazy: () => lazyRoute('AlbumPage'),
      },
      // tracks
      {
        path: 'track/:trackId/:trackName',
        lazy: () => lazyRoute('TrackPage'),
      },
      // tags
      {
        path: 'tag/:tagName',
        lazy: () => lazyRoute('TagMediaPage'),
      },
      {
        path: 'tag/:tagName/tracks',
        lazy: () => lazyRoute('TagMediaPage'),
      },
      {
        path: 'tag/:tagName/albums',
        lazy: () => lazyRoute('TagMediaPage'),
      },
      // user profile
      {
        path: 'user/:userId/:userName',
        lazy: () => lazyRoute('UserProfilePage'),
      },
      {
        path: 'user/:userId/:userName/:tabName',
        lazy: () => lazyRoute('UserProfilePage'),
      },
      // user account settings
      {
        path: '/user/account-settings',
        lazy: () => lazyRoute('AccountSettingsPage'),
      },
      // radio
      {
        path: 'radio/:seedType/:seedId/:seeName',
        lazy: () => lazyRoute('RadioPage'),
      },
      // search
      {
        path: 'search',
        lazy: () => lazyRoute('SearchResultsPage'),
      },
      {
        path: 'search/:searchQuery',
        lazy: () => lazyRoute('SearchResultsPage'),
      },
      {
        path: 'search/:searchQuery/:tabName',
        lazy: () => lazyRoute('SearchResultsPage'),
      },

      // library
      {
        loader: () => authGuard(),
        children: [
          {
            path: 'library',
            lazy: () => lazyRoute('LibraryPage'),
          },
          {
            path: 'library/songs',
            lazy: () => lazyRoute('LibraryTracksPage'),
          },
          {
            path: 'library/playlists',
            lazy: () => lazyRoute('LibraryPlaylistsPage'),
          },
          {
            path: 'library/albums',
            lazy: () => lazyRoute('LibraryAlbumsPage'),
          },
          {
            path: 'library/albums/:albumType',
            lazy: () => lazyRoute('LibraryAlbumsPage'),
          },
          {
            path: 'library/artists',
            lazy: () => lazyRoute('LibraryArtistsPage'),
          },
          {
            path: 'library/history',
            lazy: () => lazyRoute('LibraryHistoryPage'),
          },
          {
            path: 'library/tickets',
            lazy: () => lazyRoute('LibraryTicketsPage'),
          },
        ],
      },

      // Live Event
      {
        path: 'live-event/:slugOrId',
        lazy: () => lazyRoute('LiveEventPage'),
      },

      // Live Votes
      {
        path: 'live-votes',
        lazy: () => lazyRoute('LiveVotesPage'),
      },

      // Channels
      {
        path: ':slugOrId',
        lazy: () => lazyRoute('ChannelPage'),
      },
      {
        path: 'channel/:slugOrId',
        lazy: () => lazyRoute('ChannelPage'),
      },
      {
        path: ':slugOrId/:restriction',
        lazy: () => lazyRoute('ChannelPage'),
      },
      {
        path: 'channel/:slugOrId/:restriction',
        lazy: () => lazyRoute('ChannelPage'),
      },
    ],
  },
];
